<template>
  <div class="star-block" :class="{ fill }"></div>
</template>

<script>
export default {
  name: 'star',
  props: {
    fill: {
      default: false,
    },
  },
}
</script>

<style lang="scss">
.star-block {
  &::after {
    content: '';
    display: block;
    width: 17px;
    height: 17px;
    background: url('~@/assets/icons/star.svg') no-repeat center center;
  }

  &.fill::after {
    background-image: url('~@/assets/icons/star-fill.svg');
  }
}
</style>
